"use client"
import { Dialog, DialogContent } from "@mui/material"
import CloseButton from "common/CloseButton"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { Font } from "../wizard/constants"

const StyledContainer = styled.div``

const StyledDialog = styled(Dialog)`
  inset: unset !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;

  ${(p) => p.theme.breakpoints.up("md")} {
    left: auto !important;
  }
  > .cover {
    align-items: flex-end;
  }

  .continue-purchase {
    justify-content: flex-start;
    margin: 0;

    ${(p) => p.theme.breakpoints.down("sm")} {
      max-width: 100%;
      width: 100%;
    }
  }
`

const StyledHeading = styled.h2`
  font-family: ${Font.MazdaType};
  font-size: 18px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
  margin: 0;
`

const StyledContent = styled.p`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 300;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 0;
`

const StyledLink = styled.a`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.1em;
  text-align: center;
  border-bottom: 2px solid black;
  border-offset: 3px;
`

const StyledLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  cursor: pointer;
`

const StyledDialogContent = styled(DialogContent)`
  padding: 28px;
`

const ContinuePurchase = () => {
  const [continuePurchaseLink, setContinuePurchaseLink] = useState<
    string | null
  >(null)
  const [modelName, setModelName] = useState<string | null>(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    // These lines will only run on the client-side
    setContinuePurchaseLink(localStorage.getItem("CONTINUE_PURCHASE_LINK"))
    setModelName(localStorage.getItem("MODEL_NAME"))
  }, [])

  // Checks that we are not in the shop and that Use has previously
  // been working on configuring a car
  useEffect(() => {
    if (window && window?.location) {
      if (
        window?.location?.href?.includes("shop") ||
        window?.location?.href?.includes("showroomsscreens")
      )
        return
    }

    if (continuePurchaseLink) setOpen(true)
  }, [])

  return (
    <StyledContainer>
      <StyledDialog
        classes={{
          root: "continue-purchase-root",
          paper: "continue-purchase",
          scrollPaper: "continue-purchase",
        }}
        open={open}
        onClose={() => {}}
        aria-label="התחברות"
        maxWidth="xs"
        disableRestoreFocus
        style={{ padding: "20px" }}
        hideBackdrop
        disableScrollLock
        disableAutoFocus
        disableEnforceFocus
      >
        <StyledDialogContent>
          <CloseButton
            onClick={() => {
              setOpen(false)
            }}
          />
          <StyledHeading>להמשיך לרכישת {modelName}</StyledHeading>
          <StyledContent>רוצה להמשיך מאיפה שהיית?</StyledContent>
          <StyledLinkContainer>
            <StyledLink href={continuePurchaseLink || ""}>
              כן, קחו אותי לשם
            </StyledLink>
          </StyledLinkContainer>
        </StyledDialogContent>
      </StyledDialog>
    </StyledContainer>
  )
}

export default ContinuePurchase
